import { useState } from "react";
import { Link } from "react-router-dom";
import { ArrowLeftRight, MapPin } from "lucide-react";
import { PROJECTS } from "../data/site";
import { Reveal, Overline, PageHeader } from "../components/Reveal";

function BeforeAfter({ project }) {
  const [showAfter, setShowAfter] = useState(true);
  return (
    <div className="bg-white border border-border rounded-2xl overflow-hidden group" data-testid="project-card">
      <div className="relative h-64 overflow-hidden">
        <img
          src={showAfter ? project.after : project.before}
          alt={`${project.title} — ${showAfter ? "après" : "avant"}`}
          className="w-full h-full object-cover transition-all duration-500"
        />
        <span className={`absolute top-4 left-4 text-xs font-extrabold uppercase tracking-wider px-3 py-1.5 rounded-full ${showAfter ? "bg-brand text-white" : "bg-navy text-white"}`}>
          {showAfter ? "Après" : "Avant"}
        </span>
        <span className="absolute top-4 right-4 bg-white/90 text-navy text-xs font-bold px-3 py-1.5 rounded-full">{project.tag}</span>
        <button
          onClick={() => setShowAfter((s) => !s)}
          data-testid="before-after-toggle"
          className="absolute bottom-4 left-1/2 -translate-x-1/2 bg-white text-navy font-bold text-sm py-2 px-4 rounded-full shadow-lg flex items-center gap-2 hover:bg-brand hover:text-white transition-colors"
        >
          <ArrowLeftRight className="w-4 h-4" /> {showAfter ? "Voir avant" : "Voir après"}
        </button>
      </div>
      <div className="p-6">
        <h3 className="font-display font-bold text-lg text-navy">{project.title}</h3>
        <p className="flex items-center gap-1.5 text-text-muted text-sm mt-2">
          <MapPin className="w-4 h-4 text-brand" /> {project.city}
        </p>
      </div>
    </div>
  );
}

export default function Realisations() {
  return (
    <div data-testid="realisations-page">
      <PageHeader
        overline="Réalisations"
        title="Nos chantiers avant / après"
        subtitle="Découvrez quelques-unes de nos installations et rénovations réalisées dans le Maine-et-Loire. Photos de démonstration — vos propres réalisations seront ajoutées prochainement."
      />

      <section className="max-w-7xl mx-auto px-5 md:px-10 py-24">
        <div className="grid md:grid-cols-2 lg:grid-cols-2 gap-8">
          {PROJECTS.map((p, i) => (
            <Reveal key={p.title} delay={i * 0.08}>
              <BeforeAfter project={p} />
            </Reveal>
          ))}
        </div>

        <div className="bg-surface border border-border rounded-3xl p-10 md:p-14 text-center mt-20">
          <h2 className="font-display text-2xl md:text-3xl font-extrabold text-navy">Votre projet sera notre prochaine réalisation</h2>
          <p className="text-text-muted mt-4 max-w-xl mx-auto">Confiez-nous votre installation ou votre rénovation énergétique.</p>
          <Link to="/devis" className="inline-block mt-7 bg-brand text-white font-bold py-4 px-8 rounded-full hover:bg-brand-dark transition-colors">
            Demander un devis gratuit
          </Link>
        </div>
      </section>
    </div>
  );
}
